module.exports = __webpack_public_path__ + "img/bar.7f7e5dfa.png";